<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :title="''"
      :subtitle="'Nouvelle Invitation'">
      <span
        slot="title"
        class="is-uppercase has-cursor-pointer"
        @click="$router.goBack()">
        Partenaires
      </span>
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="true"
      :has-right-col-small="true"
      :has-sticky-col-right="true"
      :set-main-col-class="'is-12'">
      <div class="has-background-white is-border">
        <div class="is-padding-left is-padding-right is-padding-top-small is-padding-bottom-small ">
          <h1 class="title is-5">
            <span class="is-uppercase has-text-weight-normal">Nouvelle invitation partenaire</span>
          </h1>
        </div>
        <form @submit.prevent.stop="submit()">
          <div class="notification is-warning is-marginless">
            <p class="is-uppercase is-size-7 ">
              Un prescripteur pourra commercialiser les programmes pour lesquels il dispose d’un droit d’accès. Il pourra dénoncer des contacts et optionner des lots.<br>
              Vous devez définir son taux de rémunération. <b>Attention</b>, vous ne pouvez pas gérer l’allotement dans le cadre d’une invitation.
            </p>
          </div>
          <div class="is-padding">
            <div class="field">
              <r-label
                :label="'Civilité'"
                :is-required="false"
                :value="title"></r-label>
              <div class="field is-grouped">
                <div class="control">
                  <input
                    :id="'title-m'"
                    :name="'title-m'"
                    type="radio"
                    value="m"
                    class="vadCheckradiocase is-primary"
                    v-model="title">
                  <label
                    :for="'title-m'"
                    class="is-minW100p">
                    <span class="icon is-size-4 "><i class="fas fa-male"></i></span>M.
                  </label>
                </div>
                <div class="cotrol">
                  <input
                    :name="'title-mme'"
                    :id="'title-mme'"
                    type="radio"
                    value="mme"
                    class="vadCheckradiocase is-primary"
                    v-model="title">
                  <label
                    :for="'title-mme'"
                    class="is-minW100p">
                    <span class="icon is-size-4"><i class="fas fa-female"></i></span>Mme
                  </label>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-4 is-3-fullhd">
                <v-input
                  id="last_name"
                  :name="'last_name'"
                  @input="val => invitation.lastName = val"
                  :model="invitation.lastName"
                  :errors-bag="errors"
                  ref="input"
                  v-validate="'required|min:2'"
                  data-vv-value-path="val"
                  data-vv-as="Nom">
                  <r-label
                    slot="label"
                    :is-required="true"
                    :red-check="errors.has('last_name')"
                    :label="'Nom'"
                    :value="invitation.lastName"></r-label>
                </v-input>
              </div>
              <div class="column is-4 is-3-fullhd">
                <v-input
                  id="first_name"
                  :name="'first_name'"
                  @input="val => invitation.firstName = val"
                  :model="invitation.firstName"
                  :errors-bag="errors"
                  v-validate="'required|min:2'"
                  data-vv-value-path="val"
                  data-vv-as="Prénom">
                  <r-label
                    slot="label"
                    :is-required="true"
                    :label="'Prénom'"
                    :value="invitation.firstName"></r-label>
                </v-input>
              </div>
            </div>
            <div class="columns">
              <div class="column is-4 is-3-fullhd">
                <v-input
                  id="email"
                  :name="'email'"
                  :disabled="isEdited"
                  @input="val => invitation.email = val.trim()"
                  :model="invitation.email"
                  :errors-bag="errors"
                  v-validate="'required|min:2'"
                  data-vv-value-path="val"
                  data-vv-as="Email"
                  :has-addons="true">
                  <r-label
                    slot="label"
                    :is-required="true"
                    :label="'Email'"
                    :value="invitation.email"></r-label>
                  <p
                    class="control"
                    slot="addonLeft">
                    <a class="button is-square is-static is-border">
                      <span class="icon"><i class="fas fa-paper-plane"></i></span>
                    </a>
                  </p>
                </v-input>
              </div>
              <div class="column is-4 is-3-fullhd">
                <v-input
                  id="phone"
                  name="phone"
                  @input="invitation.phone = $event"
                  :model="invitation.phone"
                  :errors-bag="errors"
                  :input-type="'tel'"
                  :placeholder="'06xxxxxxxx / +336xxxxxxxx'"
                  data-vv-value-path="val"
                  v-validate="'min:10'"
                  data-vv-as="Téléphone"
                  :has-addons="true">
                  <r-label
                    slot="label"
                    :is-required="false"
                    :label="'Téléphone'"
                    :value="invitation.phone"
                    :truncate="false">
                    <span
                      class="is-padding-left-xsmall"
                      v-helper.right="'6BNfgrh0uP7V5UyMRsZvQp'">
                      <i class="fal fa-info-circle"></i>
                    </span>
                  </r-label>
                  <p
                    class="control"
                    slot="addonLeft">
                    <a class="button is-square is-static is-border">
                      <span class="icon"><i class="fas fa-phone-office"></i></span>
                    </a>
                  </p>
                </v-input>
              </div>
            </div>
            <template v-if="allProgram.length > 0">
              <r-label
                :label="'Commercialisation :'"
                :is-required="false"></r-label>
              <div
                class="block is-padding-left is-padding-right-xxsmall is-border"
                :class="!global_remuneration ? '' : ' has-background-dark'">
                <div class="columns is-vcentered is-minH50p is-gapless">
                  <div class="column">
                    <div>
                      <input
                        id="global_remuneration"
                        v-model="global_remuneration"
                        name="global_remuneration"
                        class="switch is-success is-rounded"
                        type="checkbox">
                      <label
                        for="global_remuneration"
                        :class="!global_remuneration ? '' : 'has-text-white'"
                        class="is-uppercase">Appliquer LE MÊME TAUX DE COMMERCIALISATION À TOUS LES PROGRAMMES</label>
                    </div>
                  </div>
                  <template v-if="global_remuneration">
                    <div class="column is-4 is-self-stretchedd">
                      <div class="field has-addons">
                        <div class="control is-expanded">
                          <v-input
                            :name="'invitation_remuneration'"
                            @input="updateRemuneration($event)"
                            :model="remuneration"
                            :errors-bag="errors"
                            data-vv-value-path="val"
                            classes="has-text-centered"
                            :max="100"
                            :number="true"
                            input-type="number"
                            data-vv-as=" "
                            icon="fa-percentage"
                            v-validate="'required|decimal:2|min_value:0|max_value:100'"
                            :has-incrementations="true"
                            :step="0.1">
                          </v-input>
                        </div>
                        <div class="control">
                          <a class="button is-static is-square is-border">
                            <span class="icon is-small"><i class="fas fa-percentage"></i></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </template>

            <div
              v-if="allProgram.length > 0"
              class="columns is-multiline">
              <div
                class="column is-6 is-4-fullhd"
                v-for="program in allProgram"
                :key="program.pk">
                <div class="is-border is-flex is-column is-height-full">
                  <div
                    class="columns is-vcentered is-gapless is-marginless"
                    style="flex: 1 0 auto">
                    <div
                      class="column is-narrow is-self-stretched"
                      style="width: 114px;"
                      v-if="program.picture && program.picture.path">
                      <figure
                        class="image is-3by2 is-minH100"
                        :class="{'is-disabled': program.status === 'draft'}"
                        v-if="program.picture && program.picture.path">
                        <v-lazy-image :src="program.picture | avatarBig" />
                      </figure>
                      <avatar
                        v-else
                        :use-picto-custom="'fas fa-building'"
                        :force-picto="true"
                        :is-avatar="true"
                        :item="{}"
                        class="is-large is-margin-left">
                      </avatar>
                    </div>
                    <div class="column is-padding-top-xxsmall is-padding-right-xsmall is-padding-bottom-xxsmall is-padding-left-xsmall">
                      <div
                        class="columns is-gapless is-vcentered"
                        style="margin-bottom:0.1rem;">
                        <div class="column is-narrow">
                          <div class="title is-6 is-marginless">
                            <span class="has-text-weight-bold is-uppercase">{{ program.name }}</span>
                          </div>
                        </div>
                        <div class="column is-narrow is-margin-left-xxsmall">
                          <span class="has-text-weight-normal has-text-primary is-size-6">(Comm : <span v-if="program.remuneration_program"><b>{{ program.remuneration_program }}</b>%</span><span v-else>NC</span>)</span>
                        </div>
                        <div class="column is-margin-left-xxsmall">
                          <span
                            v-if="program.status === 'draft'"
                            class="tag is-draft is-xsmall">Brouillon</span>
                        </div>
                      </div>

                      <div
                        class="is-size-6 has-text-primary"
                        style="margin-bottom:0.1rem;"
                        v-if="program.address">
                        <span>{{ program.address.line1 }} {{ program.address.zip_code }} {{ program.address.city }}</span>
                      </div>

                      <div class="is-size-6  has-text-primary">
                        {{ program.lots }} lots disponibles
                      </div>
                    </div>
                  </div>
                  <div class="is-border-top columns is-gapless is-vcentered is-minH50p">
                    <div class="column is-padding-left">
                      <input
                        :id="program.pk + '-selected'"
                        type="checkbox"
                        :name="program.pk + '-selected'"
                        class="switch is-success is-medium is-rounded"
                        v-model="program.selected">
                      <label :for="program.pk + '-selected'"><span class="is-size-5">{{ program.selected ? 'Ouvert': 'Ouvrir ce programme' }}</span></label>
                    </div>
                    <div class="column is-narrow is-padding-right-xxsmall">
                      <div
                        class="field has-addons"
                        v-if="program.selected">
                        <div class="control">
                          <span
                            class="button is-border is-static"
                            :class="{'has-background-white' : !global_remuneration}">
                            <span class="is-uppercase is-size-6">
                              Taux de comm
                            </span>
                          </span>
                        </div>
                        <div class="control">
                          <v-input
                            :name="program.pk + '-rem'"
                            :model="program.remuneration"
                            @input="program.remuneration = $event"
                            :errors-bag="errors"
                            input-type="number"
                            :disabled="global_remuneration"
                            :has-incrementations="true"
                            :step="0.1"
                            v-validate="'required|decimal:2|min_value:0|max_value:100'"
                            data-vv-value-path="val"
                            data-vv-as="Rémunération"
                            class="is-w130p">
                          </v-input>
                        </div>
                        <div class="control">
                          <a class="button is-static is-border is-square">
                            <span class="icon"><i class="fas fa-percentage"></i></span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="field is-border-top has-background-light is-padding-small"
            @mouseover="displayToolbar = true"
            @mouseleave="displayToolbar = false">
            <div class="control">
              <r-label
                :label="'Ajouter un message à votre invitation : (Facultatif)'"
                :is-required="false"
                :value="invitation.message"></r-label>
              <wysiwyg-editor
                :model="invitation.message"
                placeholder=""
                id="descText"
                name="descText"
                @change="val => invitation.message = val"
                :light-program="true"
                :light="true"
                :tooltip-top="true"
                :class="{'editr--hide-toolbar':!displayToolbar}"
                class="editr--bottom-toolbar has-background-white editr--height-medium content"
                data-type-cy="wysiwyg-editor"
                data-value-cy="input_desc" />
            </div>
          </div>
          <submit-sticky-buttons
            @submit="submit"
            :loading="submitLoading"
            button-id="accessForm"></submit-sticky-buttons>
        </form>
      </div>
    </page-content>
  </div>
</template>

<script>
import { DefaultValues } from '@/mixins'
import ErrorMixin from '@/mixins/ErrorMixin'
import { cloneDeep } from 'lodash'
export default {
  name: 'NewInvitation',
  mixins: [ErrorMixin, DefaultValues],
  data () {
    return {
      submitLoading: false,
      programs: [],
      tauxError: [],
      allProgram: [],
      global_remuneration: false,
      remuneration: 0,
      title: null,
      displayToolbar: false,
      invitation: {
        erase: 0,
        preAccessList: [],
        email: null,
        firstName: null,
        lastName: null
      }
    }
  },
  computed: {
    isEdited () {
      if (this.invitation.erase) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    global_remuneration (v) {
      if (v) {
        for (let program of this.allProgram) {
          program.selected = true
          if (this.remuneration) {
            program.remuneration = this.remuneration
          }
        }
      } else {
        for (let program of this.allProgram) {
          program.selected = false
          program.remuneration = program.remuneration_program ? program.remuneration_program : 0
        }
      }
    }
  },
  async created () {
    await this.getPrograms()
    if ('id' in this.$route.params && this.$route.params.id) {
      await this.getInvitation(this.$route.params.id, this.$route.params.type, this.$route.params.promoteur)
    }
  },
  methods: {
    updateRemuneration (rem) {
      this.remuneration = rem
      for (let program of this.allProgram) {
        program.remuneration = rem
      }
    },
    async getInvitation (id, data, promoteur, next) {
      let request
      try {
        if (promoteur) {
          request = await this.$api.getOne(this.$resources.INVITATION, id)
          this.invitation.lastName = request.data.last_name
          this.invitation.firstName = request.data.first_name
          this.invitation.email = request.data.email
          if (request.data.message) {
            this.invitation.message = request.data.message
          }
          if ('custom_fields' in request.data && 'title' in request.data.custom_fields) {
            this.title = request.data.custom_fields.title
          }
          if ('custom_fields' in request.data && 'phone' in request.data.custom_fields) {
            this.invitation.phone = request.data.custom_fields.phone
          }
        } else {
          next()
        }
      } catch {
        request = await this.$api.getOne(this.$resources.ACCOUNT_RELATION, id)
        let company = await this.getCompany(request.data.account_two.pk)
        this.invitation.lastName = company.first_admin.last_name
        this.invitation.firstName = company.first_admin.first_name
        // this.invitation.email = request.data.account_two.email
        // this.invitation.phone = request.data.account_two.phone
        this.invitation.email = company.first_admin.email
        this.invitation.phone = company.first_admin.phone
        if ('title' in company.first_admin && company.first_admin.title) {
          this.title = company.first_admin.title
        }
      } finally {
        this.invitation.erase = 1
        for (let access of request.data.pre_access_list) {
          let index = this.allProgram.findIndex(x => {
            return x.pk === access.program
          })
          if (index >= 0) {
            this.allProgram[index].selected = true
            this.allProgram[index].remuneration = access.remuneration
          }
        }
      }
    },
    async getCompany (id) {
      this.loading = true
      try {
        let request = await this.$api.getOne(this.$resources.ACCOUNT, id)
        return request.data
      } catch (err) {
        console.log(err)
      }
      this.loading = false
    },
    async getPrograms (query) {
      let params = {
        per_page: 200,
        sort: 'name'
      }
      let request = await this.$api.get(this.$resources.PROGRAM, params)
      this.programs = request.data.items
      for (let program of request.data.items) {
        let prog = {
          status: program.status,
          picture: program.picture ? program.picture : null,
          address: program.address,
          name: program.name,
          lots: program.available_lots ? program.available_lots : 0,
          remuneration_program: program.remuneration,
          remuneration: program.remuneration ? program.remuneration : 0,
          pk: program.pk,
          selected: false
        }
        this.allProgram.push(prog)
      }
    },
    async submit () {
      const formIsValid = await this.$validator.validateAll()
      this.submitLoading = true
      if (formIsValid) {
        let invitation = cloneDeep(this.invitation)
        let selectedProgram = this.allProgram.filter(x => x.selected)
        for (let selected of selectedProgram) {
          let program = {
            program: selected.pk,
            remuneration: selected.remuneration
          }
          if (this.global_remuneration) {
            program.remuneration = this.remuneration
          }
          invitation.preAccessList.push(program)
        }
        this.checkUser(invitation)
      } else {
        this.$toasted.global.danger('Veuillez renseignez les champs obliatoires')
        this.submitLoading = false
      }
    },
    async checkUser (invitation) {
      let request = await this.$api.axios.get('user-lookup', {
        params: {
          email: invitation.email
        }
      })
      const check = request.data
      if (check.valid && check.account !== null && check.user !== null) {
        this.newRelation(check.account, invitation)
      } else if (check.valid) {
        this.sendInvitation(invitation)
      } else if (check.account_type === 'promoteur' && !check.valid) {
        this.$toasted.global.danger('Impossible d\'inviter un promoteur')
        this.submitLoading = false
      } else {
        this.$toasted.global.danger('Cet email n\'est pas valide')
        this.submitLoading = false
      }
    },
    async newRelation (account, invitation) {
      const payload = {
        erase: invitation.erase,
        message: invitation.message,
        account_two: account,
        pre_access_list: invitation.preAccessList
      }
      try {
        await this.$api.post(this.$resources.ACCOUNT_RELATION, payload)
        await this.$toasted.global.success('Demande de mise en relation envoyée')
        this.$router.push({ name: 'RelationsList' })
      } catch (e) {
        this.submitLoading = false
        console.log(e)
        this.handleError(e)
      }
    },
    async sendInvitation (invitation) {
      let payload = {
        erase: invitation.erase,
        message: invitation.message,
        first_name: invitation.firstName,
        last_name: invitation.lastName,
        email: invitation.email,
        pre_access_list: invitation.preAccessList,
        custom_fields: {
          title: this.title,
          phone: invitation.phone
        }
      }
      try {
        await this.$api.post(this.$resources.INVITATION, payload)
        await this.$toasted.global.success('Invitation envoyée')
        await this.$router.push({ name: 'RelationsList' })
      } catch (err) {
        this.submitLoading = false
        this.handleError(err)
        console.log(err)
      }
    }
  }
}
</script>
